module.exports = __webpack_public_path__ + "static/media/Smit3.fa617b9d.png";